import React from "react";

import { Autocomplete } from "@aclymatepackages/atoms";

import { useCachedDisplayData } from "../../../helpers/firebase";
import { useTheme } from "@mui/material";

const DbAutocomplete = ({
  multiple,
  collection,
  availableOptions,
  setValue,
  queries = [],
  ...otherProps
}) => {
  const { palette } = useTheme();
  const [dbCollectionData] = useCachedDisplayData(collection, queries);

  const isMultiple = collection === "employees" || multiple;

  const options = availableOptions || dbCollectionData;

  const formatOutput = (newValue) => {
    if (!collection) {
      return newValue;
    }

    if (collection === "vehicles") {
      const { id, name, tonsCo2ePerMile, make, model, year, fuelType } =
        newValue || {};

      return (
        newValue &&
        (tonsCo2ePerMile
          ? { id, name, fuelType, tonsCo2ePerMile }
          : { id, name, make, model, year, fuelType })
      );
    }

    if (isMultiple) {
      return newValue.map((obj) => ({
        id: obj?.id,
        name: obj?.name,
        ...obj,
      }));
    }

    const { id, name } = newValue || {};
    return newValue && { id, name };
  };

  const renderOption = (props, option) => {
    if (collection === "offices") {
      const { isClosed } = option || {};

      return (
        <li {...props}>
          {option?.name}
          {isClosed && (
            <span
              style={{
                color: palette.error.main,
                fontSize: "0.8rem",
                marginLeft: "0.5rem",
              }}
            >
              (Closed)
            </span>
          )}
        </li>
      );
    }

    return <li {...props}>{option?.name}</li>;
  };

  return (
    <Autocomplete
      setValue={(value) => setValue(formatOutput(value))}
      availableOptions={options}
      multiple={isMultiple}
      renderOption={renderOption}
      {...otherProps}
    />
  );
};
export default DbAutocomplete;
